/* ++++++++++ --------------- UTILS : GENERATORS --------------- ++++++++++ */
import React from 'react';



// +++++ ID GENERATOR +++++ //
// this will be used to gauge the amount of time a user has spent for a given event fired by tracking
const s4 = () => Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
const generateId = () => s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();



// +++++ CLASS GENERATOR +++++ //
// generates classes from passed component properties
const generateClasses = (props, propsToConvertToClasses) => {
	// used to store pushed class names
    let classList = [],
    	propList = ['name', 'type', 'variant', 'behavior', 'color', 'align', 'size', 'direction', 'state', 'klass'], // these are the most consistent systemized props for components ... they may or may not be available for a component
        combinedList = [];
   	// merge default list of props, and passed props
    combinedList = propsToConvertToClasses ? propList.concat(propsToConvertToClasses) : propList;
    // loop props, see if a matching value is in the array of prop names passed, if so, store in a local array that will later be joined to created class names that will appear on an element
    Object.entries(props).forEach(prop => combinedList.includes(prop[0]) ? prop[0] === 'klass' ? classList.push(prop[1]) : classList.push(`${prop[0]}-${prop[1]}`) : null);
    // separate classes with space
    return classList.join(' ');
    // ~~~~~ sample usage ~~~~~ //
    // generateClasses(this.props, ['name', 'color', 'type', 'variant', 'iconLeft'])
    // will generate 'name-x', 'color-x', etc
};



// +++++ INFUSE CHILDREN OF A COMPONENT WITH PROPS +++++ //
// helpful when you know the immediate children are what you need to access (they are not deeply nested)
const generatePropsOnChildren = (children, props) => {
    return React.Children.map(children, (child, index) => !!child ? React.cloneElement(child, props) : null);
};



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export { generateId, generateClasses, generatePropsOnChildren };


